import { DateParser, InformationBlock } from '@dec/shared';
import { Row } from '@dec/shared';
import { label } from 'app/modules/Reports/TaxReturnList/translation';
import {
  Calendar,
  Calendar3Event,
  Check2Square,
  Icon123,
  Info,
  Lightbulb,
  PersonVcard,
  TypeItalic
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { type TaxReturnSummary } from '../models/TaxReturn';

interface TaxReturnSummaryCardProps {
  content: TaxReturnSummary;
}

export const TaxReturnSummaryCard = ({ content }: TaxReturnSummaryCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="card mb-5">
      <div className="card-body mx-3">
        <Row>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={t('config.tinLegend')}
              value={content?.taxReturnNumber}
              icon={Icon123}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'name')}
              value={content?.taxpayer?.name}
              icon={TypeItalic}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={t('config.tin')}
              value={content?.taxpayer?.tin}
              icon={PersonVcard}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'createDate')}
              value={DateParser.toString(content?.createdDate)}
              icon={Calendar}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'taxreturnType')}
              value={t(`common.taxreturn-types.${content?.taxReturnType}`)}
              icon={Info}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'taxreturnState')}
              value={t(`common.taxreturn-status.${content?.taxReturnStatus}`)}
              icon={Check2Square}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'formId')}
              value={content?.formCode.toString()}
              icon={Info}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'active')}
              value={t(`common.yes-no.${content?.active ? 'yes' : 'no'}`)}
              icon={Lightbulb}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <InformationBlock
              title={label(t, 'period')}
              value={content?.period.toString()}
              icon={Calendar3Event}
            />
          </div>
        </Row>
      </div>
    </div>
  );
};
